import Vue from "vue";

Vue.filter("currency", (value) => {
    const formatter = new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
    });
    return formatter.format(value);
  });
  